import * as React from "react";
import PropTypes from "prop-types";
import BigNumberList from "./components/big-number-list";
import IconList from "./components/icon-list";
import NumberList from "./components/number-list";
import OldList from "../v1";

function List(props) {
  const { className, icon, type, children, style } = props;
  let jsx;

  switch (type) {
    case "icon": {
      jsx = (
        <IconList className={className} icon={icon} style={style}>
          {children}
        </IconList>
      );
      break;
    }
    case "big-number": {
      jsx = (
        <BigNumberList className={className} style={style}>
          {children}
        </BigNumberList>
      );
      break;
    }
    case "number": {
      jsx = (
        <NumberList className={className} style={style}>
          {children}
        </NumberList>
      );
      break;
    }
    case "bullet": {
      jsx = (
        <OldList style={style} type="bullet">
          {children}
        </OldList>
      );
      break;
    }
    default: {
      throw new Error(`[List]: type '${type}' is unknown`);
    }
  }

  return jsx;
}

List.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(["icon", "big-number", "number"]).isRequired,
  icon: PropTypes.node,
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default List;
